import type { Tool, Service, LeadMagnet } from '@/types'

export const TOOLS: Tool[] = [
  {
    id: 'vision',
    emoji: '🎬',
    name: 'Vision Movies',
    tag: 'Vision 2026',
    desc: 'Forget vision boards. The new thing is vision movies. Upload your photo, describe 3 goals, and AI creates a cinematic movie of your future self achieving them. Perfect for visioning services and retreats.',
    cta: 'Try It Free',
    href: 'https://vision2026.web.app/',
    color: '#7C3AED',
  },
  {
    id: 'content',
    emoji: '📅',
    name: 'Content Planner',
    tag: 'Open at the Top 2026',
    desc: 'AI-powered weekly content for CSL communities: sermon research, song suggestions, social media posts, and journal prompts — all aligned to your annual theme.',
    cta: 'Explore',
    href: 'https://theme.cslleesburg.org/',
    color: '#2563EB',
  },
  {
    id: 'channel',
    emoji: '🎥',
    name: 'Channel Flow',
    tag: 'Content Engine',
    desc: 'One Sunday video becomes 10 short-form videos for TikTok, LinkedIn, YouTube, and Instagram — plus articles for email and Substack. Click for a preview (but this one\'s mine, sorry).',
    cta: 'See a Preview',
    href: '#',
    color: '#DC2626',
    action: 'youtube',
    youtubeId: 'PLACEHOLDER',
  },
  {
    id: 'affirmation',
    emoji: '✨',
    name: 'Affirmation Flow',
    tag: 'iOS & Android',
    desc: 'Daily affirmation app with 8 life areas and up to 3 daily reminders. Help your congregation carry their intention throughout the day.',
    cta: 'Download',
    href: 'https://apps.apple.com/us/app/daily-affirmation-flow/id6755495993',
    color: '#D97706',
    action: 'apps',
  },
  {
    id: 'wisdom',
    emoji: '📜',
    name: 'Ancient Wisdom Library',
    tag: 'New',
    desc: 'AI-powered access to spiritual and philosophical texts from centuries past — surfaced with modern relevance. Ask a question about life today and hear what the ancient masters had to say.',
    cta: 'Explore',
    href: 'https://wisdom.cslleesburg.org',
    color: '#9333EA',
  },
  {
    id: 'shop',
    emoji: '🛍️',
    name: 'Spirit Swag Shop',
    tag: 'Fundraising',
    desc: 'Custom-branded merchandise for your CSL community — apparel, mugs, totes, and more. Every purchase supports your center\'s mission. No inventory needed.',
    cta: 'Browse',
    href: 'https://shop.cslleesburg.org',
    color: '#E11D48',
  },
  {
    id: 'cmr',
    emoji: '📝',
    name: 'Licensed Minister Reports',
    tag: 'CMRs Made Easy',
    desc: 'Because Word documents are so last year. Submit, track, and manage your CMRs through a modern web app — guided prompts, auto-save, and one-click submission.',
    cta: 'Try It',
    href: '#',
    color: '#0891B2',
    action: 'request-access',
  },
  {
    id: 'giving',
    emoji: '💝',
    name: 'Conscious Giving',
    tag: 'Coming Soon',
    desc: 'Automate your giving campaigns with personalized pledge tracking, follow-ups, and gratitude communications. No more spreadsheets.',
    cta: 'Join Waitlist',
    href: '#',
    color: '#059669',
    action: 'request-access',
  },
]

export const SERVICES: Service[] = [
  {
    emoji: '🌐',
    title: 'Website Creation & Hosting',
    desc: 'Modern, mobile-friendly websites for spiritual centers — from design to hosting to ongoing support.',
  },
  {
    emoji: '📚',
    title: 'Course & PDF Enhancement',
    desc: 'Transform static PDFs and course materials into engaging, interactive digital experiences.',
  },
  {
    emoji: '🎯',
    title: 'Google for Nonprofits Setup',
    desc: '$127K+ in free Google tools your center is probably missing. I\'ll set up everything.',
  },
  {
    emoji: '📹',
    title: 'Livestream & Social Automation',
    desc: 'Multi-stream to Zoom + YouTube + Facebook simultaneously. Auto-chop Sunday service into weekly content.',
  },
]

export const LEAD_MAGNETS: LeadMagnet[] = [
  { title: 'Google Ad Grant Starter Kit', desc: 'Get $10K/mo in free Google Ads', emoji: '📋', slug: 'google-ad-grant-starter-kit' },
  { title: 'Free Google Tools Cheatsheet', desc: '$127K+ in tools you\'re missing', emoji: '🎁', slug: 'free-google-tools-cheatsheet' },
  { title: 'Multi-Stream Setup Checklist', desc: 'Zoom + YouTube + FB in one click', emoji: '📡', slug: 'multi-stream-setup-checklist' },
  { title: 'Content Repurposing Cheatsheet', desc: '1 Sunday service = 1 week of content', emoji: '♻️', slug: 'content-repurposing-cheatsheet' },
  { title: 'Vision Movie Experience Guide', desc: 'Run a vision movie night at your center', emoji: '🎬', slug: 'vision-movie-experience-guide' },
  { title: 'PDF-to-WOW Transformation Checklist', desc: 'Turn static PDFs into engaging experiences', emoji: '✨', slug: 'pdf-to-wow-transformation-checklist' },
  { title: 'Online Shop Quick-Start Checklist', desc: 'Launch your center\'s branded merch shop', emoji: '🛍️', slug: 'online-shop-quickstart-checklist' },
  { title: '8 Free Tech Tools Cheatsheet', desc: 'Essential tools every spiritual center needs', emoji: '🛠️', slug: '8-free-tech-tools-cheatsheet' },
]
